<template lang="pug">
.page-smart-control
  .page-header
    IQToolMiddlePaneHeader.header(:header="$t(`${baseTranslationPath}.title`)"
                           :title="pageTitle"
                           @goToListPage="back"
                           )
  SmartControlHeader(
        :smartControlRecord="smartControlRecord"
        :isOwner="isOwner"
        v-if="fileVersion"
        :fileVersion="fileVersion"
        @update-docs = "updateDocs"
    )
  Stages(:smartControlRecord="smartControlRecord" v-if="smartControlRecord" @act="actAction")
  Comments(:comments="comments"
          :documentId="documentId"
          @deleteComment="deleteComment"
          @addComment="addComment")
</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import get from 'lodash/get';
import Comments from './children/Comments.vue';
import SmartControlHeader from './children/Header.vue';
import Stages from './children/Stages.vue';
import { mapState } from 'vuex';


export default {
  name: 'SmartControlManage',
  components: {
    IQToolMiddlePaneHeader,
    Comments,
    SmartControlHeader,
    Stages,
  },
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      smartControlRecord: null,
      comments: [],
      isOwner: false,
      fileVersion: null,
      documentId: null,
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agent.profile,
    }),
    pageTitle() {
      return this.$t(`${this.baseTranslationPath}.manage_smart_control`);
    },
  },
  async mounted() {
    try {
      await this.init();
      this.isOwner = this.agent.id === get(this.smartControlRecord, 'owner.id');
      await this.fetchComments();
    } catch (error) {
      this.$aiq.notify.error(this.$t(`${this.baseTranslationPath}.fetch_failed`));
    }
  },
  methods: {
    async init() {
      const id = get(this.$route, 'params.id');
      this.documentId = id;
      const response = await this.$store.dispatch('smartControl/getSmartControl', id);
      this.smartControlRecord = get(response, 'data', {});
      const versions = get(this.smartControlRecord, 'versions', []);
      //get version with the highest id
      const latestVersion = versions.reduce((prev, current) => {
        if (!prev) return current;
        return prev.id > current.id ? prev : current;
      }, null);
      this.fileVersion = latestVersion;

    },

    async fetchComments() {
      const response = await this.$store.dispatch('smartControl/fetchComments', { id: this.documentId });
      this.comments = get(response, 'data.models', []);
    },

    async deleteComment(payload) {
      try {
        await this.$store.dispatch('smartControl/deleteComment', payload);
        this.$aiq.notify.success(this.$t(`${this.baseTranslationPath}.comment_deleted`));
        await this.fetchComments();
      } catch (error) {
        this.$aiq.notify.error('Unable to delete comment');
      }
    },
    async addComment(comment) {
      try {
        await this.$store.dispatch('smartControl/addComment', comment);
        this.$aiq.notify.success(this.$t(`${this.baseTranslationPath}.comment_added`));
        await this.fetchComments();
      } catch (error) {
        this.$aiq.notify.error('Unable to add comment');
      }
    },
    back() {
      const currentPath = this.$route.path;
      const parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'));
      // get parant name if exist
      const name = get(this.$route, 'meta.parentName');
      // move to the parent
      this.$router.push(name ? { name } : parentPath);
    },
    updateDocs(data) {
      this.smartControlRecord.versions.push(data.data);
    },
    async actAction(data) {
      try {
        await this.$store.dispatch('smartControl/SmartControlAction', {
          id: this.smartControlRecord.id,
          action: data.action,
          reason: data.reason,
        });
        this.$aiq.notify.success('Action successful');
        await this.init();
        await this.fetchComments();
      } catch (error) {
        const err = get(error, 'response.data.message', 'Unable to perform the action');
        this.$aiq.notify.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-smart-control {
    overflow-y: auto;
    height: 100vh;
    padding-top: 20px;
}
</style>